import { includes } from 'libraries/lodash'

const zeroLead = (timeComponent) => timeComponent < 10 ? `0${timeComponent}` : timeComponent

export const formattedDate = function () {
  const date = new Date()
  const year = date.getUTCFullYear()
  const month = date.getUTCMonth() + 1
  const day = date.getUTCDate()
  const hour = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const seconds = date.getUTCSeconds()
  const milliseconds = date.getUTCMilliseconds()
  return `${zeroLead(year)}/${zeroLead(month)}/${zeroLead(day)} ${zeroLead(hour)}:${zeroLead(minutes)}:${zeroLead(seconds)}:${zeroLead(milliseconds)}`
}

export const findTargetElement = function (el) {
  if (!el) {
    return null
  }

  if (!!el.dataset && Object.prototype.hasOwnProperty.call(el.dataset, 'eventCategory') && Object.prototype.hasOwnProperty.call(el.dataset, 'eventAction')) {
    return {
      aol: el.dataset.eventAol || null,
      category: el.dataset.eventCategory,
      action: el.dataset.eventAction,
      label: el.dataset.eventLabel || null
    }
  }

  if (el.nodeName === 'A' && el.target && !Object.keys(el.dataset).filter(item => !includes(item, 'track'))) {
    return {
      category: 'External link',
      action: 'Follow',
      label: el.href
    }
  }

  return findTargetElement(el.parentElement)
}
